export function InshurAnnouncementBar() {
    return (<aside aria-label="Announcement" className="bg-foreground text-background">
      <p className="mx-auto max-w-7xl px-4 py-3 text-center font-sans text-sm leading-relaxed text-pretty">
        <span className="font-semibold">INSHUR and Rentid have partnered to empower your business.</span>{" "}
        <span className="font-semibold text-[#f6bd2c]">PZ now embedded in your website&apos;s checkout.</span>
      </p>
    </aside>);
}
